/***
 * Returns if the browser is IE11
 * @returns {boolean}
 */
export const isIE11 = () => {
    let ie = '0';
    try {
        ie = navigator.userAgent.match(/(MSIE |Trident.*rv[ :])([0-9]+)/)[2];
    } catch (e) {
        // do nothing
    }

    return 11 === parseInt(ie);
};
